import {
  Button,
  Checkbox,
  ConfigProvider,
  DatePicker,
  Pagination,
  Radio,
  RadioChangeEvent,
  Select,
  Tabs,
  TabsProps,
  Tooltip,
} from "antd";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import TonalStatistic from "../components/TonalStatistic";
import {
  backThreadRemovedPost,
  changePostPage,
  feedFilterClear,
  feedFilterSubmit,
  fetchPostsThread,
  fetchStopPostsThread,
  removePost,
  setThreadFull,
} from "../redux/actions";
import {
  getPostCount,
  getPostIsLoading,
  getPostList,
  getPostPageNumber,
  getPostPageSize,
  getProduct,
  getThreadFull,
} from "../redux/selectors";
import { useAppDispatch } from "../redux/store/hooks";
import locale from "antd/es/date-picker/locale/ru_RU";
import { getFeedFilter } from "../redux/selectors/feed-filter.selectors";
import {
  CloseOutlined,
  DeleteOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import Post from "../components/post";
import IconUndo from "../components/icons/undo";
import IconChecked from "../components/icons/checked";
import FeedStatistics from "../components/feed-statistics/feed-statistics";
import { postService } from "../api";
import CustomSelectBySources from "../components/custom-select-by-sources";
import FeedStat from "../components/feed-statistics/feed-stat";

const Posts = () => {
  const [value, setValue] = useState("today");
  const { RangePicker } = DatePicker;
  const feedFilter = useSelector(getFeedFilter);
  const [tonality, setTonality] = useState(feedFilter.tonal);
  const [tonal, setTonal] = useState();
  const [repostOption, setRepostOption] = useState(feedFilter.repostoption);
  const [friendly, setFriendly] = useState(feedFilter.friendly);
  const [sorting, setSorting] = useState(feedFilter.sort);
  const [profileId, setProfileId] = useState(feedFilter.profile_id);
  const [profile, setProfile] = useState(feedFilter.profile_id);
  const [switchValue, setSwitchValue] = useState(false);
  const [checkedPosts, setCheckedPosts] = useState([]);
  const [tab, setTab] = useState("post");
  const [loading, setLoading] = useState(true);
  const [dateString, setDateString] = useState([
    feedFilter.from,
    feedFilter.to,
  ]);
  const isLoading = useSelector(getPostIsLoading);
  const postList = useSelector(getPostList);
  const postCount = useSelector(getPostCount);
  const pageNumber = useSelector(getPostPageNumber);
  const pageSize = useSelector(getPostPageSize);
  const [refSourceList, setRefSourceList] = useState<any>([]);
  const options = [
    { label: " Другое", value: "period" },
    { label: "Сегодня", value: "today" },
    { label: "7д", value: "week" },
    { label: "1м", value: "month" },
  ];
  const [source, setSource] = useState({
    smi: feedFilter.smi,
    vk: feedFilter.vk,
    tw: feedFilter.tw,
    ig: feedFilter.ig,
    tg: feedFilter.tg,
    yt: feedFilter.yt,
    dz: feedFilter.dz,
    ok: feedFilter.ok,
    fb: feedFilter.fb,
  });
  const [sourceChange, setSourceChange] = useState({
    smi: feedFilter.smi,
    vk: feedFilter.vk,
    tw: feedFilter.tw,
    ig: feedFilter.ig,
    tg: feedFilter.tg,
    yt: feedFilter.yt,
    dz: feedFilter.dz,
    ok: feedFilter.ok,
    fb: feedFilter.fb,
  });
  const [sourceOptions, setSourceOptions] = useState([
    "tg",
    "vk",
    "ok",
    "fb",
    "tw",
    "yt",
    "dz",
    "ig",
    "smi",
  ]);

  useEffect(() => {
    setLoading(true);
    postService
      .loadSources({
        thread_id: threadFull,
        sources_only: true,
        limit: 300,
      })
      .then((result) => {
        setRefSourceList(
          result.members.filter(
            (it: any) => !it?.username?.includes("проиндексировано")
          )
        );
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        setRefSourceList([]);
      });
  }, []);

  const getNetworkName = (id: any) => {
    if (id == 4) return "сми: ";
    if (id == 1) return "vk: ";
    if (id == 2) return "tw: ";
    if (id == 5) return "tg: ";
    if (id == 8) return "yt: ";
    if (id == 10) return "ok: ";
    if (id == 11) return "dz: ";
  };

  const getTitle = (title: any, id: any) => {
    if (id == 4 && title.toUpperCase().slice(0, 11) == "КОММЕРСАНТЪ")
      return title.slice(0, 11);
    else return title;
  };

  let allItems = refSourceList.map((it: any) => ({
    id: [it.profile_id + it.network_id].toString(),
    keyword:
      getNetworkName(it.network_id) + getTitle(it.username, it.network_id),
  }));

  const threadFull = useSelector(getThreadFull);
  const product = useSelector(getProduct);
  const dispatch = useAppDispatch();

  const fullThreads = [
    { id: 23022, title: "Евгений Разумишкин" },
    { id: 23069, title: "Зимняя уборка" },
    { id: 23070, title: "Дороги" },
    { id: 23067, title: "Сезонная уборка" },
    { id: 23068, title: "Общественные пространства" },
    { id: 23065, title: "Жилищный комитет" },
    { id: 23066, title: "Домовладения" },
  ];

  useEffect(() => {
    onClear();
  }, []);

  useEffect(() => {
    dispatch(
      feedFilterSubmit({
        from: dateString[0].slice(0, 10) + " 00:00:00",
        to: dateString[1].slice(0, 10) + " 23:59:59",
        smi: source.smi,
        vk: source.vk,
        tw: source.tw,
        fb: source.fb,
        ig: source.ig,
        tg: source.tg,
        yt: source.yt,
        dz: source.dz,
        ok: source.ok,
        tonal: tonality,
        friendly: friendly,
        sorting: sorting,
        profile_id: profileId,
        repostoption: repostOption,
      })
    );
    if (threadFull && tab == "post") dispatch(fetchPostsThread());
    if (threadFull && tab == "stop") dispatch(fetchStopPostsThread());
  }, [
    source,
    dateString,
    sorting,
    tonality,
    threadFull,
    repostOption,
    product,
    tab,
    profileId,
  ]);

  const onClear = (): void => {
    setDateString([
      new Date().toJSON().split("T")[0],
      new Date().toJSON().split("T")[0],
    ]);
    setSource({
      smi: true,
      vk: true,
      tw: true,
      fb: true,
      ig: true,
      tg: true,
      yt: true,
      dz: true,
      ok: true,
    });
    setValue("today");
    setSourceOptions(["tg", "vk", "ok", "yt", "dz", "smi"]);
    setTonality(null);
    setFriendly("");
    setSorting(null);
    setProfileId(null);
    setProfile(null);
    setRepostOption("whatever");
    setSwitchValue(false);
    dispatch(feedFilterClear());
    dispatch(changePostPage(1));
  };

  const onChangeRepost = (checked: boolean) => {
    setRepostOption(checked ? "containrepost" : "whatever");
    setSwitchValue(checked);
  };

  const onChange = ({ target: { value } }: RadioChangeEvent) => {
    setValue(value);

    if (value == "today")
      setDateString([
        new Date().toJSON().split("T")[0],
        new Date().toJSON().split("T")[0],
      ]);
    if (value == "week") {
      const start = new Date();
      start.setDate(start.getDate() - 6);
      setDateString([
        start.toJSON().split("T")[0],
        new Date().toJSON().split("T")[0],
      ]);
    }
    if (value == "month") {
      const start = new Date();
      start.setDate(start.getDate() - 29);
      setDateString([
        start.toJSON().split("T")[0],
        new Date().toJSON().split("T")[0],
      ]);
    }
  };

  const onPeriodChange = (value: any, dateString: string[]): void => {
    setDateString(dateString);
    dispatch(changePostPage(1));
  };

  const handleChangeSort = (value: string) => {
    setSorting(value);
    dispatch(changePostPage(1));
  };

  const handleChangeProfile = (value: any) => {
    console.log("valuevaluevalue", value);
    let profile =
      value == 0
        ? value
        : value?.slice(-1) == 1
        ? -value?.slice(0, -1)
        : value?.slice(0, -1);
    setProfileId(profile);
    setProfile(value);
    console.log("profileprofile", profile);
    dispatch(changePostPage(1));
  };

  const handleChangeTonal = (value: string) => {
    setTonality(value);
    dispatch(changePostPage(1));
  };

  const handleChangeSource = (value: string[]) => {
    for (let key in source) {
      value.indexOf(key) != -1
        ? setSourceChange((prevState) => ({
            ...prevState,
            [key]: true,
          }))
        : setSourceChange((prevState) => ({
            ...prevState,
            [key]: false,
          }));
    }
    setSourceOptions(value);
    //dispatch(changePostPage(1));
  };

  const changeSources = () => {
    setSource(sourceChange);
    dispatch(changePostPage(1));
  };

  const onCheck: any = (target: any, post: any) => {
    let checkedPostsArr: any = [...checkedPosts];
    if (target == true) checkedPostsArr.push(post);
    else if (target == false) {
      const filteredNumbers = checkedPostsArr.filter(
        (it: any) => it.id !== post.id
      );
      checkedPostsArr = filteredNumbers;
    }
    setCheckedPosts(checkedPostsArr);
  };

  const selectAll = () => {
    let checkedPostsArr: any = [];
    postList?.forEach((post) => checkedPostsArr.push(post));
    setCheckedPosts(checkedPostsArr);
  };

  const deleteAll = () => {
    if (tab == "post")
      checkedPosts?.forEach((post: any) => {
        dispatch(
          removePost(threadFull, post.id, post.ownerId, post.network.id)
        );
        setCheckedPosts([]);
      });
    if (tab == "stop")
      checkedPosts?.forEach((post: any) => {
        dispatch(
          backThreadRemovedPost(
            threadFull,
            post.id,
            post.ownerId,
            post.network.id
          )
        );
        setCheckedPosts([]);
        //dispatch(removeThreadPost(post.id, post.ownerId, post.network.id))
      });
    if (threadFull && tab == "post") dispatch(fetchPostsThread());
    if (threadFull && tab == "stop")
      setTimeout(() => dispatch(fetchStopPostsThread()), 1000);
  };

  const items: TabsProps["items"] = [
    {
      key: "post",
      label: "Посты",
      //children: 'Content of Tab Pane 1',
    },
    {
      key: "stop",
      label: "Исключенные",
      //children: 'Content of Tab Pane 2',
    },
  ];

  const onChangeTab = (key: string) => {
    setTab(key);
    dispatch(changePostPage(1));
  };

  const changeTonal = (value: any) => {
    console.log(value);
    setTonal(value);
  };

  return (
    <div className="App">
      <h1>Лента ЖКХ</h1>
      <div className="btn-group">
        {fullThreads?.map((competitor: any, id) => (
          <Button
            key={id}
            type={threadFull == competitor?.id ? "primary" : "default"}
            onClick={() => {
              onChangeTab("post");
              dispatch(changePostPage(1));
              dispatch(setThreadFull(competitor?.id));
              setTab("post");
            }}
          >
            {competitor?.title}
          </Button>
        ))}
      </div>
      <TonalStatistic tonal={tonal} />
      {!isLoading && (
        <Tabs
          className="tabs-group"
          defaultActiveKey={tab}
          items={items}
          onChange={onChangeTab}
        />
      )}
      <div className="white-block">
        {tab == "post" && (
          <>
            <FeedStat />
            <div className="flex-space">
              <div className="flex">
                <ConfigProvider
                  theme={{
                    components: {
                      Select: {
                        activeBorderColor: "#7856FE",
                      },
                    },
                  }}
                >
                  <Select
                    style={{ width: 195 }}
                    allowClear={false}
                    onChange={handleChangeSort}
                    disabled={isLoading}
                    options={[
                      { value: "dateAsc", label: "Сначала старые" },
                      { value: "dateDesc", label: "Сначала новые" },
                      { value: "viewDesc", label: "Больше просмотров" },
                      { value: "viewAsc", label: "Меньше просмотров" },
                      { value: "comDesc", label: "Больше комментариев" },
                      { value: "comAsc", label: "Меньше комментариев" },
                      { value: "repostDesc", label: "Больше репостов" },
                      { value: "repostAsc", label: "Меньше репостов" },
                      { value: "likeDesc", label: "Больше лайков" },
                      { value: "likeAsc", label: "Меньше лайков" },
                    ]}
                    placeholder="Сортировать по"
                  />
                </ConfigProvider>
                <ConfigProvider
                  theme={{
                    components: {
                      Select: {
                        activeBorderColor: "#7856FE",
                      },
                    },
                  }}
                >
                  <Select
                    value={sourceOptions}
                    mode="multiple"
                    allowClear={true}
                    style={{ width: 200 }}
                    maxTagCount={"responsive"}
                    disabled={isLoading}
                    options={[
                      { value: "tg", label: "Telegram" },
                      { value: "vk", label: "ВКонтакте" },
                      { value: "ok", label: "Одноклассники" },
                      //{ value: "fb", label: "Facebook" },
                      //{ value: "tw", label: "Twitter" },
                      { value: "dz", label: "Дзен" },
                      { value: "yt", label: "Youtube" },
                      //{ value: "ig", label: "Instagram" },
                      { value: "smi", label: "СМИ" },
                    ]}
                    placeholder="Тип источника"
                    dropdownRender={(menu) => (
                      <>
                        {menu}

                        <Button type="text" onClick={changeSources}>
                          Применить
                        </Button>
                      </>
                    )}
                    onChange={handleChangeSource}
                    maxTagPlaceholder={(omittedValues) => (
                      <Tooltip
                        color={"#7856FE"}
                        overlayStyle={{ pointerEvents: "none" }}
                        title={omittedValues
                          .map(({ label }) => label)
                          .join(", ")}
                      >
                        <span>Типы источников</span>
                      </Tooltip>
                    )}
                  />
                </ConfigProvider>

                <CustomSelectBySources
                  items={allItems}
                  onChange={handleChangeProfile}
                  value={profile}
                  isLoading={isLoading}
                  withSearch={true}
                />
                <ConfigProvider
                  theme={{
                    components: {
                      Select: {
                        activeBorderColor: "#7856FE",
                      },
                    },
                  }}
                >
                  <Select
                    style={{ width: 195 }}
                    allowClear={false}
                    onChange={handleChangeTonal}
                    disabled={isLoading}
                    options={[
                      { value: null, label: "Все" },
                      { value: 1, label: "Позитивные" },
                      { value: -1, label: "Негативные" },
                      { value: 0, label: "Нейтральные" },
                      /*{ value: "unset", label: "Не задана" },*/
                    ]}
                    placeholder="Тональность"
                  />
                </ConfigProvider>
                {/*<div className="left-border">
                  <p className={isLoading ? "grey" : ""}>Наличие репоста</p>
                  <ConfigProvider
                    theme={{
                      token: {
                        colorPrimary: "#D8CCFB",
                        colorPrimaryHover: "#D8CCFB",
                        colorTextTertiary: "rgba(0, 0, 0, 0.2)",
                        colorTextQuaternary: "rgba(0, 0, 0, 0.1)",
                        fontSize: 10,
                      },
                      components: {
                        Switch: {
                          handleSize: 22,
                          trackPadding: -2,
                        },
                      },
                    }}
                  >
                    <Switch
                      value={switchValue}
                      onChange={onChangeRepost}
                      disabled={isLoading}
                    />
                  </ConfigProvider>
                  </div>*/}
              </div>

              <div className="flex">
                <ConfigProvider
                  theme={{
                    components: {
                      Radio: {
                        buttonSolidCheckedColor: "#7856FE",
                        buttonSolidCheckedBg: "rgba(0, 0, 0, 0.1)",
                        colorPrimary: "rgba(0, 0, 0, 0.1)",
                        buttonSolidCheckedHoverBg: "rgba(0, 0, 0, 0.2)",
                      },
                    },
                  }}
                >
                  <Radio.Group
                    options={options}
                    onChange={onChange}
                    value={value}
                    optionType="button"
                    buttonStyle="solid"
                    disabled={isLoading}
                  />
                </ConfigProvider>

                {value == "period" && (
                  <RangePicker
                    format={"DD.MM.YYYY"}
                    onChange={onPeriodChange}
                    style={{ width: "278px" }}
                    className="choose-period"
                    allowClear={false}
                    locale={locale}
                  />
                )}
              </div>
            </div>
          </>
        )}

        <div className="feed-posts">
          {isLoading && (
            <div className="feed-posts-loader">
              <LoadingOutlined />
            </div>
          )}
          {!isLoading && postCount > 0 && (
            <>
              <div className="flex">
                <div className="grey">
                  Всего постов: {(+postCount).toLocaleString()}
                </div>
                {tab == "post" && (
                  <p onClick={onClear} className="flex clear">
                    Очистить фильтры <CloseOutlined className="info" />
                  </p>
                )}
              </div>
              <div className="post-list">
                {postList?.map((item, id) => (
                  <div className="flex" key={id}>
                    <ConfigProvider
                      theme={{
                        token: {
                          colorPrimary: "#7856FE",
                          colorPrimaryHover: "rgba(0, 0, 0, 0.1)",
                          controlInteractiveSize: 25,
                        },
                      }}
                    >
                      <Checkbox
                        checked={
                          checkedPosts.findIndex(
                            (it: any) => it.id == item.id
                          ) != -1
                        }
                        onChange={(e) => onCheck(e.target.checked, item)}
                      ></Checkbox>
                    </ConfigProvider>
                    <Post key={item.id} post={item} changeTonal={changeTonal} />
                  </div>
                ))}
              </div>
              {postCount > 0 ? (
                <div className="feed-posts-pagination">
                  <Pagination
                    size="small"
                    onChange={(value) => {
                      dispatch(changePostPage(value));
                      if (threadFull && tab == "post")
                        dispatch(fetchPostsThread());
                      if (threadFull && tab == "stop")
                        dispatch(fetchStopPostsThread());
                    }}
                    total={postCount}
                    pageSize={pageSize}
                    current={pageNumber}
                    hideOnSinglePage={true}
                    showSizeChanger={false}
                  />
                </div>
              ) : null}
            </>
          )}
          {!isLoading && postCount == 0 && (
            <div className="flex">
              <div className="feed-posts__empty">Постов пока нет</div>
              <p onClick={onClear}>
                Очистить фильтры <CloseOutlined className="info" />
              </p>
            </div>
          )}
        </div>
      </div>
      {checkedPosts.length > 0 && (
        <div className="fixed-block flex-space">
          <div className="flex">
            <a onClick={selectAll} className="flex btn-cursor">
              <IconChecked />
              Выбрать все
            </a>
            <a onClick={() => setCheckedPosts([])} className="flex btn-cursor">
              <IconUndo />
              Сбросить
            </a>
          </div>
          <div className="flex">
            <div className="grey">Постов выбрано: {checkedPosts.length}</div>
            <div className="red-bg red btn-cursor" onClick={deleteAll}>
              <DeleteOutlined />{" "}
              {tab == "post" ? "Исключить" : "Вернуть в ленту"}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Posts;
